module.exports = __webpack_public_path__ + "img/ECU_for_Nissan_Leaf2.186d8476.jpg";